export const initFacebookPixel = () => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    } else {
    }
  };
  
  export const trackEvent = (eventName, params = {}) => {
    if (window.fbq) {
      window.fbq('track', eventName, params);
    }
  };
  